import { IconSrc } from '@/types/Icon'
import Image from 'next/image'

type IconProps = {
    src: IconSrc
    alt: string
    className: string
}

// download the 32dp svg from:
// https://marketingportal.extranet.deutschebahn.com/marketingportal/Marke-und-Design/Basiselemente/Icons/Icon-Bibliotheken/Bibliothek-Funktionale-Icons

export default function Icon({ className, src, alt }: IconProps) {
    return <Image className={className} src={src} alt={alt} />
}
